import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>(theme => ({
  mark: {
    background: theme.palette.common.gray300,
    borderRadius: 0,
    bottom: theme.spacing(-0.5),
    height: theme.spacing(1),
    opacity: 1,
    width: theme.spacing(0.125),
  },
  markLabel: {
    fontSize: theme.typography.fontSize * 0.857,
    marginTop: theme.spacing(1.25),
  },
  rail: {
    '&.noBorderRadius': {
      borderRadius: 0,
    },
    background: theme.palette.common.gray200,
    borderRadius: theme.spacing(7.5),
    height: theme.spacing(0.75),
    opacity: 1,
  },
  root: {
    height: theme.spacing(0.75),
  },
  thumb: {
    '&.MuiSlider-active': {
      boxShadow: '0px 0px 0px 8px rgba(0, 160, 255, 0.16)',
    },
    '&:hover': {
      boxShadow: 'none',
    },
    background: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.gray300}`,
    height: theme.spacing(4),
    justifyContent: 'space-between',
    marginLeft: theme.spacing(-2),
    marginTop: 0,
    padding: `0px ${theme.spacing(1.25)}px`,
    top: '50%',
    transform: 'translateY(-50%)',
    width: theme.spacing(4),
  },
  thumbArrowLeft: {
    transform: 'rotate(180deg)',
  },
  track: {
    '&.noBorderRadius': {
      borderRadius: 0,
    },
    borderRadius: theme.spacing(7.5),
    height: theme.spacing(0.75),
  },
}));

export default useStyles;
